import { createContext } from "react";
import type { WellnessStore } from "../WellnessMetadataProvider.types";

const WellnessStoreContext = createContext<WellnessStore | undefined>(undefined);
WellnessStoreContext.displayName = "WellnessStoreContext";

export default WellnessStoreContext;
